import { useState, useEffect } from 'react';
import { createContainer } from 'ui-components/src/services/ContextProvider';
import { makeCancelable } from 'ui-components/src/utilities/makeCancelable';
import { Configuration } from './types';

function useConfig<T extends Configuration>(): T {
  const [config, setConfig] = useState<T>();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await window.fetch(`${getBasePath()}/config.json`);
        const data = await response.json();
        setConfig(data);
      } catch (err) {
        setConfig(() => {
          throw new Error(err as string);
        });
      }
    };

    const callRef = makeCancelable(fetchConfig());
    return () => {
      callRef.cancel();
    };
  }, []);

  return config!;
}

function getBasePath(): string {
  // When we're in Storybook, don't use a prefix
  if (
    window.location.hostname === 'localhost' &&
    window.location.port === '9009'
  )
    return '';
  const pathParts = window.location.pathname.split('/');
  return pathParts[1] ? `/${pathParts[1]}` : '';
}

export const ConfigContext = createContainer(useConfig);
